import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  WritableSignal,
  input,
  output,
  signal,
} from '@angular/core';

@Component({
  selector: 'lib-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccordionComponent implements OnInit {
  id = input<string>();
  title = input<string>();
  subTitle = input<string>();
  success = input<boolean>();
  error = input<boolean>();
  disabled = input<boolean>();
  isOpen = input<boolean>(false);
  alwaysOpen = input<boolean>(false);
  previewMode = input<boolean>(false);
  hover = input<boolean>();
  bodyWidth = input<'small' | 'medium' | 'full'>('full');
  alwaysRender = input<boolean>();
  forordnandeStyle = input<boolean>();
  collapse = output<boolean>();

  isOpenSignal: WritableSignal<boolean> = signal(false);
  isVisible: WritableSignal<boolean> = signal(false);

  @ViewChild('accordionContainer') accordionContainerRef: ElementRef;

  ngOnInit() {
    this.isOpenSignal.set(this.alwaysOpen() ? true : this.isOpen());
    this.isVisible.set(this.isOpenSignal());
  }

  toggleCollapse() {
    if (this.disabled() || this.alwaysOpen()) {
      return;
    }
    this.isOpenSignal.update((val) => !val);
    this.collapse.emit(this.isOpenSignal());
  }
}
